import type { AnnotationType } from '../../labelling/types';
import type { AnnotationDataT } from '../../labelling/types/annotations.type';

/**
 * Returns the number of renderable points for a geometry + annotationType pair.
 * Mirrors getPointCount but operates on raw geometry instead of a full AnnotationT.
 *
 * - RECTANGLE: 4 (corners derived from x,y,width,height)
 * - POLYGON: N (vertex count)
 * - POLYLINE: N (vertex count)
 * - ELLIPSE: 2 (two axis-defining points: center+radiusX, center+radiusY)
 * - KEY_POINT: 1
 * - SKELETON: N (node count)
 * - CUBOID: 8 (fixed 8 corners)
 * - SEGMENTATION: 0 (bitmap-based, not point-based)
 * - FRAME_CLASSIFICATION: 0 (no geometry)
 */
export function getPointCountFromGeometry(geometry: AnnotationDataT, annotationType: AnnotationType): number {
  switch (annotationType) {
    case 'RECTANGLE':
      {
        return 4;
      }
    case 'ELLIPSE':
      {
        return 2;
      }
    case 'KEY_POINT':
      {
        return 1;
      }
    case 'POLYGON':
    case 'POLYLINE':
    case 'CUBOID':
      {
        const data = (geometry as {
          points?: unknown[];
        });
        return data.points?.length ?? 0;
      }
    case 'SKELETON':
      {
        const data = (geometry as {
          nodes?: unknown[];
        });
        return data.nodes?.length ?? 0;
      }
    case 'SEGMENTATION':
    case 'FRAME_CLASSIFICATION':
    default:
      {
        return 0;
      }
  }
}